/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Makes it easy to display a message notification over a map.
 *
 * @example
 * ```javascript
 * var mBox = new L.MessageBox({
 *   content:'Hello world',
 *   closeAfter: 1000
 * });
 * mBox.addTo(map);
 * ```
 *
 * @class MessageBox
 * @namespace L
 * @extends L.Layer
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {Boolean} [options.closeable=true] Show the close button
 * @param {Number} [options.closeAfter=0] Number of milliseconds after which the control will be automatically
 *     closed. If value is `0` it will not be closed automatically, which is the default behaviour.
 */
/* jshint nomen:false */
define(['leaflet', 'services/utils'], function(L, Utils) {
    'use strict';

    L.MessageBox = L.Layer.extend({
        options: {
            closeable: true,
            closeAfter: 0
        },

        initialize: function(options) {
            L.Util.setOptions(this, options);
        },

        onAdd: function(map) {
            var that;
            this._map = map;
            this._container = this.container = L.DomUtil.create('div', 'leaflet-messageBox tomtom-copyrights');
            this.contentContainer = L.DomUtil.create('div', 'leaflet-messageBox-content', this.container);
            if (this.options.closeable) {
                this.closeButton = L.DomUtil.create('div', 'leaflet-messageBox-close-button', this.container);
                this.closeButton.innerHTML = '&#215;';
                L.DomEvent.on(this.closeButton, 'click', this.onRemove, this);
            }
            that = this;
            if (this.options.closeAfter && parseInt(this.options.closeAfter, 10) === this.options.closeAfter) {
                setTimeout(function() {
                    that.close();
                }, this.options.closeAfter);
            }
            L.DomEvent.disableClickPropagation(this.container);
            L.DomEvent.disableScrollPropagation(this.container);

            if (this.options.content) {
                this.setContent(this.options.content);
            }

            map._container.appendChild(this.container);
            return this.container;
        },
        addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        onRemove: function() {
            if (this._map._container.contains(this.container)) {
                this._map._container.removeChild(this.container);
            }
            return this;
        },
        /**
         * Sets the HTML content of the message box.
         *
         * @chainable
         * @method setContent
         * @param {String|HTMLElement} content The text or {{#crossLink "HTMLElement"}}{{/crossLink}} to be a content
         * of the message box
         * @return {L.MessageBox}
         */
        setContent: function(content) {
            if (!this.contentContainer) {
                this.options.content = content;
                return this;
            }
            if (Utils.isString(content)) {
                this.contentContainer.innerHTML = content || '';
                return this;
            }
            while (this.contentContainer.firstChild) {
                this.contentContainer.lastChild.remove();
            }
            this.contentContainer.appendChild(content);
            return this;
        },
        close: function() {
            return this.onRemove();
        },
        openOn: function(map) {
            return this.addTo(map);
        }
    });

    L.messageBox = function(options) {
        return new L.MessageBox(options);
    };

    return L.messageBox;
});



// WEBPACK FOOTER //
// ./display/messageBox.js